import React, { useEffect, useState } from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Select from '@nmx/template/dist/componentLibrary/components/forms/Select';
// native components
import PodcastEpisodeCard from './components/podcastEpisodeCard';
// styles
import {
  ColStyled,
  RowStyled,
  SectionContainerStyled,
} from './styles';
// utilities
import {
  getSeasonDate,
  getSeasonsWithEpisodes,
  generateSeasonOptionsList,
  reorderPodcastEpisodes,
  sanitizeJson,
} from './utilities/utilities';

const pushAdobeDataLayer = (seasonNumber) => {
  if (window.adobeDataLayer) {
    window.adobeDataLayer.push({
      event: 'seasonChange',
      seasonChange: { selectedSeason: seasonNumber },
    });
  }
};

export default (podcastEpisodeItems) => {
  let sanitizedPodcastEpisodeData = podcastEpisodeItems.podcastEpisodeItems;
  const [reverseOrder, setReverseOrder] = useState(false);

  useEffect(() => {
    setReverseOrder(true);
  }, []);

  try{
    sanitizedPodcastEpisodeData = sanitizeJson(podcastEpisodeItems.podcastEpisodeItems);
  }catch(err){
    console.error(err);
  }

  const seasonsWithEpisodes = getSeasonsWithEpisodes(sanitizedPodcastEpisodeData);
  const podcastSeasonOptionsList = generateSeasonOptionsList(seasonsWithEpisodes);

  // set the default value to be the newest season that has episodes
  const [values, setValues] = useState({ seasonNumber: podcastSeasonOptionsList[podcastSeasonOptionsList.length - 1]?.value || '' });

  // determine the episodes in the selected season
  const filteredEpisodesBySeason = sanitizedPodcastEpisodeData.filter(item => {
    const season = item.entity?.fieldBody[0]?.entity?.fieldPodcastEpisode?.entity.fieldPartOfSeason;
    return season && season.toString() === values.seasonNumber;
  });

  // gets the first date in a season for use in schema
  const date = getSeasonDate(filteredEpisodesBySeason);

  // initialize and populate orderedPodcastEpisodesArray
  let orderedPodcastEpisodesArray = [];
  try{
    orderedPodcastEpisodesArray = reorderPodcastEpisodes(filteredEpisodesBySeason);

    if (reverseOrder && orderedPodcastEpisodesArray) {
      orderedPodcastEpisodesArray.reverse();
    }
  }catch(err){
    console.error(err);
  }

  const handleChange = (e) => {
    const newSeasonNumber = e.target.value;
    setValues({
      ...values,
      seasonNumber: newSeasonNumber,
    });

    // update analytics
    pushAdobeDataLayer(newSeasonNumber);
  };

  return (
    <SectionContainerStyled
      id='podcast-episode-grouping'
      itemScope
      itemType='https://schema.org/PodcastSeason'
      disableBottomPadding>
      <meta
        itemProp='seasonNumber'
        content={values.seasonNumber}
      />
      <meta
        itemProp='partOfSeries'
        content='A Better Way To Money&#174;'
      />
      {date && (
        <meta
          itemProp='datePublished'
          content={date}
        />
      )}
      <Col medium={4}>
        <Select
          id='podcast-season-select'
          name='podcast-season'
          labelText='Select a season:'
          onChange={handleChange}
          value={values.seasonNumber}
          options={podcastSeasonOptionsList}
        />
      </Col>
      <meta
        itemProp='numberOfEpisodes'
        content={filteredEpisodesBySeason.length}
      />
      <AssistiveText component='h2'>
        Podcast episodes
      </AssistiveText>
      {orderedPodcastEpisodesArray.length > 0 && (
        <RowStyled
          role='list'
          aria-roledescription='ordered'>
          {orderedPodcastEpisodesArray.map((item, index) => {
            const episode = item.entity?.fieldBody[0]?.entity?.fieldPodcastEpisode?.entity;
            const articleLinkPath = item.entity?.path?.alias;
            return (
              <ColStyled
                key={`podcast-episode-column-${episode.name}`}
                medium={6}
                large={4}
                role='listitem'>
                <PodcastEpisodeCard
                  data={episode}
                  articleLinkPath={articleLinkPath.toString()}
                  itemIndex={index}
                />
              </ColStyled>
            );
          })}
        </RowStyled>
      )}
    </SectionContainerStyled>
  );
};
